// extracted by mini-css-extract-plugin
export default {"container":"FloatingButtons_container__f8Axu","button":"FloatingButtons_button__uIRje"};